export default "__VITE_ASSET__BRBRp67J__";